import {documentReady} from './utils';
import {selectRedirect, handleClearInput, togglePassword, inputRangeSync, toggleCheckboxList} from './helpers';

const Forms = {
    initialize: () => {
        documentReady(() => {
            Forms.inputClearInit();
            Forms.checkboxesToggleInit();
            Forms.selectRedirectInit();
            Forms.inputRangeInit();
            Forms.togglePasswordInit();
        });
    },

    inputClearInit: () => {
        const items = document.querySelectorAll('.js-input-clear');
        for (const item of items) {
            item.addEventListener('click', handleClearInput);
        }
    },

    checkboxesToggleInit: () => {
        const items = document.querySelectorAll('.js-checkbox-list-all, .js-checkbox-list-none');
        for (const item of items) {
            item.addEventListener('click', toggleCheckboxList);
        }
    },

    selectRedirectInit: () => {
        const items = document.querySelectorAll('.js-select-redirect');
        for (const item of items) {
            item.addEventListener('change', selectRedirect);
        }
    },

    inputRangeInit: () => {
        const items = document.querySelectorAll('.js-input-range [type="range"]');
        for (const item of items) {
            item.addEventListener('input', inputRangeSync);
        }
    },

    togglePasswordInit: () => {
        const items = document.querySelectorAll('.js-toggle-password');
        for (const item of items) {
            item.addEventListener('click', togglePassword);
        }
    }
}

Forms.initialize();

export default Forms;
